var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteEye = function SvgWhiteEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0.2 C8.77243209,0.2 11.1246189,2.20542172 12,5.00001241 C11.1246189,7.79457828 8.77243209,9.8 6,9.8 C3.22756791,9.8 0.875381142,7.79460311 -3.01980663e-14,5.00001241 C0.875381142,2.20542172 3.22756791,0.2 6,0.2 Z M6,1.80001241 C4.34313246,1.80001241 3,3.23268704 3,5.00001241 C3,6.76731296 4.34313246,8.20001241 6,8.20001241 C7.65686754,8.20001241 9,6.76728813 9,5.00001241 C9,3.23268704 7.65686754,1.80001241 6,1.80001241 Z M7.06065684,3.86864511 C7.64643996,4.49348044 7.64643996,5.50654439 7.06065684,6.13137971 C6.47487373,6.75621504 5.52512627,6.75621504 4.93934316,6.13137971 C4.35356004,5.50654439 4.35356004,4.49348044 4.93934316,3.86864511 C5.52512627,3.24380979 6.47487373,3.24380979 7.06065684,3.86864511 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-Workout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.3-Workout-/-Livestream-/-Video",
    transform: "translate(-100.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Status-Copy",
    transform: "translate(92.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Copy",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_eye-show",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -1.000000)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12,
    height: 12
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-eye.00767a24.svg";
export { ForwardRef as ReactComponent };